import { mapActions, mapGetters, mapMutations } from 'vuex'
import { debounce } from 'lodash'

export default {
    name: 'setting-llm-parameters-filter',
    data () {
        return {
            filter: {
                keywords: ''
            }
        }
    },
    computed: {
        ...mapGetters({
            filterKeywords: 'settingLlmParameters/filterKeywords'
        })
    },
    created () {
        this.setFilters()
    },
    methods: {
        ...mapActions({
            fetchList: 'settingLlmParameters/GET_LIST'
        }),
        ...mapMutations({
            changeFilter: 'settingLlmParameters/CHANGE_LIST_FILTER',
            setListLength: 'settingLlmParameters/SET_LIST_LENGTH',
            changeSkip: 'settingLlmParameters/CHANGE_SKIP'
        }),
        setFilters () {
            this.filter.keywords = this.filterKeywords
        },
        sendRequest: debounce(function () {
            this.fetchList()
        }, 500),
        changeFilterLocal (val, type) {
            this.changeFilter({
                type: type,
                value: val
            })

            this.sendRequest()

            this.setListLength(0)
            this.changeSkip(0)
        }
    }
}
